import React from "react";
import PropTypes from "prop-types";

const DigiFormNote = ({ value }) => (
  <div>
    {value && (
      <div class="mb-10 mt-15">
        <span className="grey-text line-break">
          {value}
        </span>
      </div>
    )}
  </div>
);

DigiFormNote.propType = {
  value: PropTypes.string
};

export default DigiFormNote;
